import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
//import forge from "node-forge";
import { API_URL } from '../config/api';
import BRANDING from "../config/branding";

const LoginForm = () => {
	const navigate = useNavigate();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false); // New state for loading


	const handleSubmit = async (e) => {
	e.preventDefault();
	setLoading(true);

	try {
		const response = await axios.post(
			 `${API_URL}/login.php`,
				{
					email,
					password,
				}
			);

		console.log(response.data);

		if (response.data.mfa_required) {
			toast.info("Multi-factor authentication required.");
			localStorage.setItem("email", email);
			sessionStorage.setItem("mfa_email", email);
			navigate("/mfa");
		} else if (
			response.data.status ||
			response.data.success === "success"
		) {
			toast.success("Successfully sent OTP to user");

			sessionStorage.setItem(
				"token",
				response.data.token
			);

			localStorage.setItem("email", email);

			navigate("/otp");
		} else {
			toast.error(
				response.data.message ||
				"Invalid credentials."
			);
		}
	} catch (error) {
		console.error("Login error:", error);

		toast.error(
			error?.response?.data?.message ||
			"Login failed."
		);
	} finally {
		setLoading(false);
	}
};

	useEffect(() => {
		const token = localStorage.getItem("token");
		if (token) {
			navigate("/dashboard", { replace: true });
		}
	}, [navigate]);

	return (
		<div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-white font-inter'>
			<div className='max-w-md w-full bg-white p-10 rounded-2xl border border-slate-200 shadow-xl'>
				<div className='flex justify-center mb-6'>
    <div className='flex justify-center mb-6'>
    <img
        src={BRANDING.logo}
        alt={BRANDING.shortName}
        className='h-16 w-auto'
    />
</div>
</div>
				<div><h2 className='text-3xl font-bold text-center mb-2'
	style={{ color: BRANDING.primaryColor }}>
    {BRANDING.portalTitle}
</h2>

<p className='text-center text-slate-500 mb-8'>
    {BRANDING.portalSubtitle}
</p>

					<form onSubmit={handleSubmit} className='space-y-6'>
						<div>
							<label
								htmlFor='email'
								 className='block text-sm font-semibold text-slate-700'
							>
								Email
							</label>
							<input
								type='email'
								id='email'
								value={email}
								onChange={(e) => setEmail(e.target.value)}
							className='w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-red-600'
								required
							/>
						</div>
						<div>
							<label
								htmlFor='email'
								 className='block text-sm font-semibold text-slate-700'
							>
								Password
							</label>
							<input
								type='password'
								id='password'
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								className='w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-red-600'
								required
							/>
						</div>
						<button
							type='submit'
							disabled={loading}
							className='w-full py-3 mt-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700'
						>
							{loading ? "Signing In..." : "Sign In"}{" "}
						</button>
					</form>
				</div>
			</div>
		</div>
	);
};

export default LoginForm;
